import { render } from "./vision.vue?vue&type=template&id=5a5c04a2&scoped=true&ts=true"
import script from "./vision.vue?vue&type=script&lang=ts"
export * from "./vision.vue?vue&type=script&lang=ts"

import "./vision.vue?vue&type=style&index=0&id=5a5c04a2&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5c04a2"]])

export default __exports__